<template>
  <v-card>
    <v-navigation-drawer
      v-model="drawer"
      class="rounded-0"
      :style="{ backgroundColor: 'var(--color-theme)' }"
      dark
      app
      mini-variant
      :mini-variant-width="miniVariantWidth"
      :mobile-breakpoint="0"
      permanent
    >
      <v-list-item class="px-2 justify-start">
        <v-app-bar-nav-icon @click.stop="navbarWithName = !navbarWithName"></v-app-bar-nav-icon>
      </v-list-item>

      <v-divider></v-divider>
      <!--Navbar utama-->
      <v-list dense nav>
        <v-list-item class="justify-start">
          <v-list-item-icon style="cursor: pointer" @click="isNavbarOpen = true">
            <v-icon>
              mdi-view-dashboard
            </v-icon>
          </v-list-item-icon>
          <v-bottom-sheet v-model="isNavbarOpen">
            <v-sheet
              class="text-center"
              style="background-color: rgba(0,0,0,0.5); overflow-x: auto; overflow-y: hidden;"
              height="200px"
            >
              <div class="my-3">
                <v-row
                  class="pa-4 flex-nowrap"
                  style="width: max-content; min-width: 100%;"
                >
                  <v-flex v-for="(actparent, i) in menuparent" :key="i" router :to="actparent.route" lg2 class="px-4">
                    <v-hover v-slot="{ hover }" close-delay="200">
                      <v-card
                        class="pa-5 mb-6 rounded-lg"
                        :elevation="hover ? 20 : 0"
                        :class="{ 'on-hover': hover }"
                        height="170px"
                        outlined
                        flat
                        :to="actparent.MODULE_URL"
                        @click="getMenuPrivilage(), getMenuauth(actparent.MODULE_ID)"
                      >
                        <div class="card-body text-center">
                          <p>
                            <img :src="actparent.MODULE_NAME + '.png'" width="80">
                          </p>
                          <h4 class="card-title font-weight-medium">
                            {{ actparent.MODULE_NAME }}
                          </h4>
                        </div>
                      </v-card>
                    </v-hover>
                  </v-flex>

                  <!--card My Profile-->
                  <v-flex lg2 class="px-4">
                    <v-hover v-slot="{ hover }" close-delay="200">
                      <v-card
                        class="pa-6 mb-6 rounded-lg"
                        :elevation="hover ? 20 : 0"
                        :class="{ 'on-hover': hover }"
                        height="170px"
                        outlined
                        flat
                        to="/profile"
                        @click="getProfile()"
                      >
                        <div class="card-body text-center">
                          <p>
                            <img src="My Profile.png" width="80">
                          </p>
                          <h4 class="card-title font-weight-medium">
                            My Profile
                          </h4>
                        </div>
                      </v-card>
                    </v-hover>
                  </v-flex>
                  <!--End card My Profile-->
                </v-row>
              </div>
            </v-sheet>
          </v-bottom-sheet>
        </v-list-item>
        <!-- <div v-show="menufunction" v-if="menuchild.length > 0 || (routePath == menuchild[0].MODULE_URL && menuchild[0].MODULE_STATUS_SUB == 1)"> -->
        <div v-show="menufunction" v-if="menuchild.length > 0 ">
          <div v-for="(val, key) in menuchild[0].MODULE_CHILD" :key="key">
            <div v-if="navbarWithName == false">
              <!-- single menu  -->
              <div v-if="val.MODULE_CHILD_SUB.length == 0 && key == 0">
                <v-tooltip v-for="(val, i) in menuchild[0].MODULE_CHILD" :key="i" router :to="val.route" right>
                  <template v-slot:activator="{ on }">
                    <!-- <v-list-item v-on="on" dense :to="val.MODULE_URL" @click="getPrivilageAction(val.PRIVILAGE_ID);"> -->
                    <v-list-item
                      v-on="on"
                      dense
                      :to="val.MODULE_URL"
                      @click="getPrivilageAction(val.MODULE_NAME ,'','' ,val.MODULE_URL, val.HAS_INSERT, val.HAS_UPDATE, val.HAS_DELETE, val.HAS_VIEW)"
                    >
                      <v-list-item-icon>
                        <v-icon>
                          {{ val.MODULE_ICON }}
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>
                        {{ val.MODULE_NAME }} 
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                  <span>
                    {{ val.MODULE_NAME }}
                  </span>
                </v-tooltip>
              </div>
              <div v-else-if="val.MODULE_CHILD_SUB.length > 0">
                <v-list-item dense>
                  <v-menu :menu-props="{ maxWidth: '250', maxHeight: '600' }" :close-on-content-click="false" :nudge-width="100" offset-x>
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item-icon v-bind="attrs" v-on="on">
                        <v-icon>
                          {{ val.MODULE_ICON }}
                        </v-icon>
                      </v-list-item-icon>
                    </template>
                    <v-card>
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list v-for="(item, i) in val.MODULE_CHILD_SUB" :key="i">
                              <!-- two sub menu -->
                              <div v-if="item.MODULE_STATUS_SUB == 0">
                                <v-list-item
                                  dense
                                  router
                                  :to="item.MODULE_URL"
                                  @click="getPrivilageAction(val.MODULE_NAME ,item.MODULE_NAME,'',item.MODULE_URL, item.HAS_INSERT, item.HAS_UPDATE, item.HAS_DELETE, item.HAS_VIEW)"
                                >
                                  <v-list-item-icon>
                                    <v-icon>
                                      {{ item.MODULE_ICON }}
                                    </v-icon>
                                  </v-list-item-icon>
                                  <v-list-item-title>
                                    {{ item.MODULE_NAME }} 
                                  </v-list-item-title>
                                </v-list-item>
                              </div>
                              <!-- three sub menu -->
                              <div v-else-if="item.MODULE_STATUS_SUB == 1" :nudge-width="100">
                                <v-list-group small :value="false" :prepend-icon="item.MODULE_ICON">
                                  <template v-slot:activator>
                                    <v-list-item-title class="body-2">
                                      {{ item.MODULE_NAME }}
                                    </v-list-item-title>
                                  </template>
                                  <v-list-item
                                    v-for="(vals, i) in item.MODULE_CHILD_SUB_SUB"
                                    :key="i"
                                    dense
                                    router
                                    :to="vals.MODULE_URL"
                                    @click="getPrivilageAction(val.MODULE_NAME ,item.MODULE_NAME,vals.MODULE_NAME,vals.MODULE_URL, vals.HAS_INSERT, vals.HAS_UPDATE, vals.HAS_DELETE, vals.HAS_VIEW)"
                                  >
                                    <v-list-item-icon>
                                      <v-icon>
                                        {{ vals.MODULE_ICON }}
                                      </v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                      <v-list-item-title>
                                        {{ vals.MODULE_NAME }}
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list-group>
                              </div>
                            </v-list>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-menu>
                </v-list-item>
              </div>
            </div>
            <div v-if="navbarWithName == true">
              <!-- single menu  -->
              <div v-if="val.MODULE_CHILD_SUB.length == 0 && key == 0">
                <div v-for="(val, i) in menuchild[0].MODULE_CHILD" :key="i" router :to="val.route">
                  <!-- <v-list-item v-on="on" dense :to="val.MODULE_URL" @click="getPrivilageAction(val.PRIVILAGE_ID);"> -->
                  <v-list-item
                    class="justify-start"
                    dense
                    :to="val.MODULE_URL"
                    @click="getPrivilageAction(val.MODULE_NAME,'','' ,val.MODULE_URL, val.HAS_INSERT, val.HAS_UPDATE, val.HAS_DELETE, val.HAS_VIEW)"
                  >
                    <v-list-item-icon>
                      <v-icon>
                        {{ val.MODULE_ICON }}
                      </v-icon>
                      <v-list-item-content class="ml-2 d-flex align-center">
                        <v-list-item-title class="text-center" style="font-size: 14px;">
                          {{ val.MODULE_NAME }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item-icon>
                  </v-list-item>
                </div>
              </div>
              <div v-else-if="val.MODULE_CHILD_SUB.length > 0">
                <v-list-item class="justify-start" dense>
                  <v-menu :menu-props="{ maxWidth: '250', maxHeight: '600' }" :close-on-content-click="false" :nudge-width="100" offset-x>
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item-icon v-bind="attrs" v-on="on">
                        <v-icon>
                          {{ val.MODULE_ICON }}
                        </v-icon>
                        <v-list-item-content class="ml-2 d-flex align-center">
                          <v-list-item-title class="text-center" style="font-size: 14px;">
                            {{ val.MODULE_NAME }} 
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item-icon>
                    </template>
                    <v-card>
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list v-for="(item, i) in val.MODULE_CHILD_SUB" :key="i">
                              <!-- two sub menu -->
                              <div v-if="item.MODULE_STATUS_SUB == 0">
                                <v-list-item
                                  dense
                                  router
                                  :to="item.MODULE_URL"
                                  @click="getPrivilageAction(val.MODULE_NAME,item.MODULE_NAME ,'' ,val.MODULE_URL, item.HAS_INSERT, item.HAS_UPDATE, item.HAS_DELETE, item.HAS_VIEW)"
                                >
                                  <v-list-item-icon>
                                    <v-icon>
                                      {{ item.MODULE_ICON }}
                                    </v-icon>
                                  </v-list-item-icon>
                                  <v-list-item-title>
                                    {{ item.MODULE_NAME }}
                                  </v-list-item-title>
                                </v-list-item>
                              </div>
                              <!-- three sub menu -->
                              <div v-else-if="item.MODULE_STATUS_SUB == 1" :nudge-width="100">
                                <v-list-group small :value="false" :prepend-icon="item.MODULE_ICON">
                                  <template v-slot:activator>
                                    <v-list-item-title class="body-2">
                                      {{ item.MODULE_NAME }} 
                                    </v-list-item-title>
                                  </template>
                                  <v-list-item
                                    v-for="(vals, i) in item.MODULE_CHILD_SUB_SUB"
                                    :key="i"
                                    dense
                                    router
                                    :to="vals.MODULE_URL"
                                    @click="getPrivilageAction(val.MODULE_NAME ,item.MODULE_NAME ,vals.MODULE_NAME ,vals.MODULE_URL, vals.HAS_INSERT, vals.HAS_UPDATE, vals.HAS_DELETE, vals.HAS_VIEW)"
                                  >
                                    <v-list-item-icon>
                                      <v-icon>
                                        {{ vals.MODULE_ICON }}
                                      </v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                      <v-list-item-title>
                                        {{ vals.MODULE_NAME }} 
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list-group>
                              </div>
                            </v-list>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-menu>
                </v-list-item>
              </div>
            </div>
          </div>
          <span></span>
          <!-- </v-list-item> -->
        </div>

        <v-tooltip v-if="navbarWithName == false" right>
          <template v-slot:activator="{ on }">
            <v-list-item v-on="on" dense @click="logoutuser">
              <v-list-item-icon>
                <v-icon>
                  mdi-logout
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                Logout
              </v-list-item-title>
            </v-list-item>
          </template>
          <span>
            Logout
          </span>
        </v-tooltip>
        <v-list-item v-if="navbarWithName == true" class="justify-start" dense @click="logoutuser">
          <v-list-item-icon>
            <v-icon>
              mdi-logout
            </v-icon>
            <v-list-item-title v-if="navbarWithName == true" class="ml-2" style="font-size: 14px;">
              Logout
            </v-list-item-title>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
      <!--end Navbar utama-->
    </v-navigation-drawer>

    <v-app-bar class="custom-app-bar" :color="$route.name == 'Generative AI' ? '#fff' : '#f7f6f4'" flat app>
      <div
        class="navbar-content"
        :class="{ 'with-name': navbarWithName }"
        style="cursor: pointer;"
        @click="$router.push('/dashboard')"
      >
        <img :src="logo" :style="{ height: 'var(--logo-height)', width: 'var(--logo-width)' }" alt="" />
        <div v-if="logo && logo.includes('logosetneg')" class="navbar-title">
          Kementerian Sekretariat Negara<br>
          Republik Indonesia
        </div>
      </div>
      <v-spacer></v-spacer>
      <v-col cols="4">
        <!-- <v-text-field
          class="mt-4"
          label="Search here"
          prepend-icon="mdi-magnify"
        ></v-text-field> -->
      </v-col>
      <div class="text-center">
        <Notification ref="alert"></Notification>

        <v-btn icon dark :style="{ color: 'var(--color-theme)' }" to="/profile">
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </div>

      <v-menu offset-y bottom :right="true">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon>
            <v-badge
              v-if="total_notifikasi_tmp > 0"
              class="mr-6"
              :color="'var(--color-theme)'"
              :content="total_notifikasi_tmp"
            >
              <v-icon>mdi-bell</v-icon>
            </v-badge>
            <v-icon v-else>
              mdi-bell
            </v-icon>
          </v-btn>
        </template>

        <!--update list notification-->
        <v-list style="min-width: 250px;">
          <v-list-item-content class="ml-4">
            <v-list-item-title>
              you have {{total_notifikasi_tmp}} notification unread
            </v-list-item-title>
          </v-list-item-content>
          <v-divider></v-divider>
          
          <v-list style="max-height: 500px; overflow-y: auto;" >
            <v-list-item-group  v-for="(notifikasi, index) in notifikasi_tmp" :key="index">
              <v-list-item >
                <v-list-item-title class="body-2">
                  <v-icon small>mdi-bell</v-icon> 
                  <span v-html="notifikasi.text"></span>
                </v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-title align="center" justify="center" class="body-2">
              <template>
                <v-btn :color="'var(--color-theme)'" text small @click="viewallnotif">
                  View all
                </v-btn>
              </template>
            </v-list-item-title>
          </v-list-item>
        </v-list>
        <!--end list notification-->
      </v-menu>

      <v-btn
        class="elevation-0"
        :style="{
          backgroundColor: 'var(--color-theme)',
          marginRight: navbarWithName ? '-4px' : '20px'
        }"
        small
        rounded
        dark
        @click="logoutuser"
      >
        <v-icon small class="mr-1">mdi-logout</v-icon>
        Logout
      </v-btn>
    </v-app-bar>
    <!-- dialog notifikasi  -->
    <v-dialog v-model="dialognotifikasi" max-width="500px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn text small color="blue darken-2"   v-bind="attrs" v-on="on">
          View all
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h6">Notifikasi</span>
        </v-card-title>
        <v-card-text height="auto">
          <!-- Looping berdasarkan tanggal untuk menampilkan grup notifikasi -->
          <div v-for="(notifs, date) in groupedNotifications" :key="date">
            <!-- Tanggal sebagai header -->
            <v-subheader>{{ (date) }}</v-subheader>

            <!-- Item notifikasi di bawah tanggal -->
            <v-list-item-group>
              <v-list-item
                v-for="(notifikasi, index) in notifs"
                :key="index"
                 @click="viewNotification(notifikasi.user_id)"
              >
                <v-list-item-icon>
                  <v-icon color="blue darken-2">mdi-bell</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <!-- Teks notifikasi -->
                  <v-list-item-title class="body-2">
                    <span v-html="notifikasi.text"></span>
                  </v-list-item-title>
                  <!-- Waktu sebagai subtitle -->
                  <v-list-item-subtitle class="grey--text text--darken-1">
                    {{ time_t(notifikasi.date) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="py-3">
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="closenotifikasi">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog notifikasi  -->

  </v-card>
  
</template>

<script>
  import axios from "axios";
  import Notification from '@/components/Notification';
  import { datemonth, timedate } from '@/components/utils/utils.js';
  import io from 'socket.io-client';

  export default {
    components: {
      Notification: Notification
    },
    data () {
      return {
        logo: null,
        logoWidth: null,
        dialognotifikasi: false,
        navbarWithName: false,
        socket: io(process.env.VUE_APP_BASE_URL_API),
        //socket: "",
        isNavbarOpen: false,
        menufunction: false,
        dialog: false,
        drawer: true,
        mini: true,
        show: false,
        if_demo: 1,
        routePath: "",
        menuparent: [],
        menuchild: [],
        notifikasi_tmp: [],
        total_notifikasi_tmp: 0,
        logout: [
          { title: 'Logout', icon: 'mdi-logout', route:'/' },
        ],
      }
    },
    computed: {
      miniVariantWidth() {
        return this.navbarWithName ? 220 : 56;
      },

      groupedNotifications() {
        return this.notifikasi_tmp.reduce((groups, notifikasi) => {
          // Format tanggal tanpa waktu, misalnya: "7 November 2024"
          const dateKey = datemonth(notifikasi.date);

          // Kelompokkan notifikasi berdasarkan tanggal
          if (!groups[dateKey]) {
            groups[dateKey] = [];
          }
          groups[dateKey].push(notifikasi);

          return groups;
        }, {});
      }
    },
    watch: {
      navbarWithName(newVal) {
        this.$emit('updateNavbarWithName', newVal);
      }
    },
    async created() {
      try {
        const appTitle = window.APP_CONFIG?.VUE_APP_TITLE || process.env.VUE_APP_TITLE;
        const assetsModule = appTitle == "Websitemedan"
          ? await import('@/constants/asset-logo-MedAn.js')
          : await import('@/constants/asset-logo-Garuda.js');

        this.logo = assetsModule.LOGO_WEB;
        const width = getComputedStyle(document.documentElement)
          .getPropertyValue('--logo-width').trim();
        this.logoWidth = width;
        this.$store.state.navbarWithName = false;
      } catch (error) {
        console.error('Failed to load assets:', error);
      }
    },
    mounted() {
      this.getMenuPrivilage();
      this.notifikasi();
      this.notifikasi_store();
      // this.getRoutePath();
    },
    methods: {
      viewNotification(userId) {
        this.getMenuPrivilage()
        this.getMenuauth(1)//default adminitration module 1
        this.$router.push({ name: 'registrasiuser', params: { userId } });
        this.dialognotifikasi = false;
      },
      date_t(dateString) {
        return datemonth(dateString);

      },
      time_t(dateString) {
        return timedate(dateString);

      },
      viewallnotif() {
        let group = JSON.parse(localStorage.getItem('group'));
        if(group.GROUP_NAME.toUpperCase() == 'SUPER ADMIN' || group.GROUP_NAME.toUpperCase() == 'ADMIN'){
            axios({
              method: "put",
              url: "read-notif",
              headers:{'auth-token':localStorage.getItem('token_app')},
              dataType: 'json'
            })
            .then((response) => {
              var status = response.data.status
              if(status == 200){
                  this.dialognotifikasi = true;
                  this.notifikasi_store();
              }

              
            })
            .catch(function (error) {
              console.log(error);
            })
        }
      },
       closenotifikasi() {
        this.dialognotifikasi = false;

      },
      async notifikasi_store() {
        let group = JSON.parse(localStorage.getItem('group'));
        if(group.GROUP_NAME.toUpperCase() == 'SUPER ADMIN' || group.GROUP_NAME.toUpperCase() == 'ADMIN'){
          this.notifikasi_tmp=[]
          this.total_notifikasi_tmp =0;
          axios.get("/notifikasi", 
            { headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
              var status = response.data.status
              var data = response.data.data
              if(status == 200){
                  data.sort((a, b) => new Date(b.date) - new Date(a.date));
                  data.forEach((element) => {
                    if(element['read'] == null){
                      this.notifikasi_tmp.push(element);
                      this.total_notifikasi_tmp =this.notifikasi_tmp.length;
                      const audio = new Audio('audio/notifikasi.mp3'); // Create a new Audio object
                      audio.play() // Play the audio
                      .catch(error => {
                        console.error('Error playing sound:', error);
                        this.handlePlaybackError(error);
                      });
                    }else{
                      this.notifikasi_tmp.push(element);
                    }
                  });
              }
            })
          .catch((e) => {
                
            this.errors=e.response.data.msg;
          });  
        }
      },
      async notifikasi() {
        this.socket.on('notifikasi_register', (data_socket) => {
            console.log('Message from server:', data_socket);
            let group = JSON.parse(localStorage.getItem('group'));
            if(group.GROUP_NAME.toUpperCase() == 'SUPER ADMIN' || group.GROUP_NAME.toUpperCase() == 'ADMIN'){
                // data_socket.forEach((element) => {
                // });
                this.notifikasi_tmp.push(data_socket);
                this.notifikasi_tmp.sort((a, b) => new Date(b.date) - new Date(a.date));
                this.total_notifikasi_tmp =this.notifikasi_tmp.length;
                const audio = new Audio('audio/notifikasi.mp3'); // Create a new Audio object
                audio.play() // Play the audio
                .catch(error => {
                  console.error('Error playing sound:', error);
                  this.handlePlaybackError(error);
                });// Sorts `notifikasi_tmp` in ascending order by date

            }

        });
      },
      handlePlaybackError(error) {
        if (error.name === 'NotAllowedError') {
          this.errorMessage = 'Audio playback is blocked. Please ensure you interact with the page first.';
        } else {
          this.errorMessage = 'An error occurred while trying to play the audio.';
        }
      },
      async logoutuser() {
        try {
          const response = await axios.delete("logout", {
            headers: { 'auth-token': localStorage.getItem('token_app') }
          });

          if (response.status == 200 || response.status == 204) {
            localStorage.removeItem('username');
            localStorage.removeItem('token_app');
            localStorage.removeItem('email');
            localStorage.removeItem('authmenu');
            localStorage.removeItem('module');
            localStorage.removeItem('not_access');

            localStorage.removeItem('authactinsert');
            localStorage.removeItem('authactupdate');
            localStorage.removeItem('authactdelete');
            localStorage.removeItem('authactview');
            localStorage.removeItem('menuPrivilage');
            localStorage.removeItem('tmpmenuPrivilage');
            localStorage.removeItem('nik');
            localStorage.removeItem('group');

            this.$router.push('/');
          } else {
            this.$router.push('/');
          }
        } catch (error) {
          console.error(error);
          this.$router.push('/');
        }
      },

      getProfile() {
        this.menufunction = false;
        this.isNavbarOpen = false;
        // alert('aaa');
        // this.getProfilMenu = "Y";
      },
      getMenuPrivilage() {
        this.isNavbarOpen = false;
        this.routePath = window.location.pathname;
        if (this.routePath !== '/profile') {
          this.menufunction = true;
        }
        let menuPrivilage = JSON.parse(localStorage.getItem('menuPrivilage'));
        let module_seed = null;
        let currentPath = this.routePath;
        for (const parent of menuPrivilage) {
          if (Array.isArray(parent.MODULE_CHILD)) {
            for (const child of parent.MODULE_CHILD) {
              if (child.MODULE_URL == currentPath) {
                module_seed = child.MODULE_PARENT_ID;
                break;
              }
              if (Array.isArray(child.MODULE_CHILD_SUB)) {
                for (const sub of child.MODULE_CHILD_SUB) {
       

                  if (sub.MODULE_URL == currentPath) {

                    module_seed = child.MODULE_PARENT_ID;
                    break;
                  }



                  if (Array.isArray(sub.MODULE_CHILD_SUB_SUB)) {
                    for (const subsub of sub.MODULE_CHILD_SUB_SUB) {
                      if (subsub.MODULE_URL == currentPath) {
                        module_seed = child.MODULE_PARENT_ID;
                        break;
                      }

                    }
                  }

                  if (module_seed) break;
                }
              }

              if (module_seed) break;
            }
          }

          if (parent.MODULE_URL == currentPath) {
            module_seed = parent.MODULE_ID;
          }

          if (module_seed) break;
        }

        if (!module_seed && menuPrivilage.length > 0) {
          module_seed = menuPrivilage[0].MODULE_ID;
        }
        this.menuparent = menuPrivilage;
        this.getMenuauth(module_seed);
      },
      getMenuauth(module_id) {
// alert(this.routePath);

        this.menuchild = [];
        localStorage.setItem("module", module_id);
        var tmp = [];
        for (const menuact of this.menuparent) {
          if (module_id == menuact.MODULE_ID ) {
            tmp.push(menuact);
          }
        }
        this.menuchild = tmp;
      },

      getPrivilageAction(title,title2,title3,module,insertdt, updatedt, deletedt, viewdt) {
        this.$store.commit("setModuleMenu", {
          title: title,
          title2: title2,
          title3: title3,
          module: module,
          update: updatedt,
          delete: deletedt,
          insert: insertdt,
          view: viewdt,
        });
        localStorage.setItem("authactinsert", insertdt);
        localStorage.setItem("authactupdate", updatedt);
        localStorage.setItem("authactdeletedt", deletedt);
        localStorage.setItem("authactview", viewdt);
      },
      // getRoutePath() {
        
      //   this.routePath = this.$route.path;
      //   // alert(this.$route.path)
      // },
    }
  }
</script>

<style scoped>
.custom-app-bar {
  padding-top: var(--layout-padding-top);
  height: var(--layout-height) !important;
}

.navbar-content {
  display: flex;
  align-items: center;
  margin-left: var(--navbar-margin-left-default) !important;
}

.navbar-content.with-name {
  margin-left: var(--navbar-margin-left-wide) !important;
}

.navbar-title {
  margin-left: var(--title-margin-left);
  font-family: var(--title-font-family);
  font-weight: var(--title-font-weight);
  font-style: var(--title-font-style);
  font-size: var(--title-font-size);
  line-height: var(--title-line-height);
  letter-spacing: var(--title-letter-spacing);
  color: var(--title-color);
}

.v-avatar.color-avatar {
  box-shadow: 0 5px 15px rgba(119, 0, 255, 0.4);
  background-image:
  linear-gradient(to right top, #5a6fe8, #6174ea, #6879ed, #6f7fef, #7584f1, #7d8af3, #8590f5, #8d96f7, #989ff9, #a2a7fb, #acb0fd, #b6b9ff);
}
.v-avatar.color-avatar2 {
  box-shadow: 0 5px 15px rgba(220, 38, 95, 0.4);
  background-image:
  linear-gradient(to right top, #ec6497, #ef6d94, #f27693, #f47f92, #f58892, #f78f91, #f99791, #fa9e91, #fca690, #fdae8f, #feb690, #febe91);
}
.v-avatar.color-avatar3 {
  box-shadow: 0 5px 15px rgba(0, 55, 255, 0.4);
  background-image:
  linear-gradient(to right top, #5d8de3, #5c92e4, #5b96e5, #5c9be6, #5d9fe6, #5da3e7, #5ea6e7, #5faae8, #5faee9, #5fb2ea, #60b6eb, #61baec);
}
.v-avatar.color-avatar4 {
  box-shadow: 0 5px 15px rgba(51, 255, 0, 0.4);
  background-image:
  linear-gradient(to right top, #53d166, #5dd468, #65d769, #6eda6b, #76dd6d, #7ee06f, #86e271, #8de573, #96e876, #9fec79, #a8ef7c, #b1f27f);
}
.v-avatar.color-avatar5 {
  box-shadow: 0 5px 15px rgba(255, 153, 0, 0.4);
  background-image:
  linear-gradient(to right top, #fac070, #fcc46a, #fec864, #ffcc5e, #ffd057, #ffd359, #ffd65a, #ffd95c, #ffdb66, #ffde6f, #ffe079, #ffe282);
}

.v-menu__content {
  max-width:20%;
  min-width: 124px; top: 12px; left: 55px; transform-origin: left top; z-index: 8;
}
</style>